module.exports = __webpack_public_path__ + "static/media/babyfoot.25e7f3e9.jpg";